import {Component, ViewEncapsulation} from '@angular/core';
import {EditorControlsService} from '../editor-controls.service';
import {Settings} from '../../../editor-tools/core/config/settings.service';
import {CanvasService} from '../../../image-editor/canvas/canvas.service';
import {NavItem} from '../../../image-editor/default-settings';
import {ExportToolService} from '../../../image-editor/tools/export/export-tool.service';
import {MergeToolService} from '../../../image-editor/tools/merge/merge-tool.service';
import {HistoryToolService} from '../../../image-editor/history/history-tool.service';
import {EditorUiService} from '../../editor-ui.service';
import { Toast } from '../../../editor-tools/core/ui/toast.service';

@Component({
    selector: 'navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavigationBarComponent {

    navItems =  [{
    position: 'top',
        replaceDefault: false,
            items: [
                { name: 'filter', icon: 'filter-custom', action: 'filter' },
                { type: 'separator' },
                { name: 'resize', icon: 'resize-custom', action: 'resize' },
                { name: 'crop', icon: 'crop-custom', action: 'crop' },
                { name: 'transform', icon: 'transform-custom', action: 'rotate' },
                { type: 'separator' },
                { name: 'draw', icon: 'pencil-custom', action: 'draw' },
                { name: 'text', icon: 'text-box-custom', action: 'text' },
                { name: 'shapes', icon: 'polygon-custom', action: 'shapes' },
                { type: 'separator' },
                { name: 'background', icon: 'background-custom', action: 'background' },
                { name: 'merge', icon: 'merge-custom', action: 'merge' },
            ]
}];

    /**
     * NavigationBarComponent Constructor.
     */
    constructor(
        public controls: EditorControlsService,
        public canvas: CanvasService,
        private saveTool: ExportToolService,
        public config: Settings,
        public mergeTool: MergeToolService,
        private history: HistoryToolService,
        public editorUi: EditorUiService,
        private toast: Toast,
    ) {}

    public executeNavItemAction(item: NavItem) {
        if (item.action === 'merge') {
            return this.merge();
        } else if (typeof item.action === 'string') {
            return this.controls.togglePanel(item.action);
        } else if (typeof item.action === 'function') {
            item.action();
        }
    }

    /**
     * Check if specified nav item should be disabled.
     */
    public navItemIsDisabled(item: NavItem): boolean {
        const hasMainImage = !!this.canvas.getMainImage();

        if (item.name === 'merge') {
            return ! this.mergeTool.canMerge();
        } else if (item.name === 'transform') {
            return !hasMainImage;
        } else if (item.name === 'background') {
            return hasMainImage;
        } else {
            return false;
        }
    }

    private merge() {
        this.mergeTool.apply().then(() => {
            this.history.add('objects: merged', this.controls.getIconName('merge'));
            this.toast.open('Objects merged.');
        });
    }
}
